(function () {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const attr = this.getAttribute("href");
      const target = document.querySelector(attr);
      target.scrollIntoView({ behavior: "smooth" });
      history.replaceState({}, "", attr);
      target.classList.add("flash-fade");
      setTimeout(() => {
        target.classList.remove("flash-fade");
      }, 2000);
      // Special case for the email subscribe box
      if (attr === "#subscribe") {
        document
          .querySelector(".gh-subscribe .gh-subscribe-input-text")
          .focus();
      }
    });
  });

  // add amazon affilite id to all amazon links
  document
    .querySelectorAll(
      'a[href^="https://smile.amazon."],a[href^="https://www.amazon."]'
    )
    .forEach((anchor) => {
      if (anchor.href.includes("?tag=adc0c8-20")) {
        return;
      }
      let tag = "?tag=adc0c8-20";
      if (anchor.href.includes("?")) {
        tag = "&tag=adc0c8-20";
      }
      anchor.setAttribute("href", anchor.getAttribute("href").replace('smile.amazon','www.amazon') + tag);
    });
})();
